module.exports = __webpack_public_path__ + "img/logo_cimb_niaga.d19d1299.png";